import { render, staticRenderFns } from "./TodasSims.vue?vue&type=template&id=43169bbc&"
import script from "./TodasSims.vue?vue&type=script&lang=ts&"
export * from "./TodasSims.vue?vue&type=script&lang=ts&"
import style0 from "./TodasSims.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports